<template>
  <img :src="thumbImage" />
</template>

<script lang="ts">
import { computed, defineComponent, unref } from "vue";
import { shipThumb } from "~/lib/thumbs";
import { useYukiDataStore } from "~/stores";

export default defineComponent({
  name: "ShipThumb",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    return {
      thumbImage: computed(() => {
        const dataStore = useYukiDataStore();
        const ship = dataStore.ships.find((x) => x.id == props.id);
        return unref(shipThumb(ship?.art_id || props.id));
      }),
    };
  },
});
</script>
